<ng-container *transloco="let t; prefix: 'thematic-list'">
    <!-- ═══════════════════════════════════════════════════════════════════════ -->
    <!--  MODE COMPACT : bandelette verticale rétractée (style nav-strip)        -->
    <!-- ═══════════════════════════════════════════════════════════════════════ -->
    @if (mode() === 'compact') {
        <div
            class="thematic-strip"
            @compactAnim
            (click)="onCompactClick()"
            [matTooltip]="
                current()?.description ?? t('select-thematic-placeholder')
            "
            matRipple
        >
            <button
                class="thematic-strip__chevron"
                (click)="$event.stopPropagation(); onCompactClick()"
            >
                <mat-icon svgIcon="heroicons_solid:chevron-left" />
            </button>
            <span class="thematic-strip__title">{{
                current()?.name ?? '—'
            }}</span>
            <span class="thematic-strip__label">{{ t('strip-label') }}</span>
        </div>
    }

    <!-- ═══════════════════════════════════════════════════════════════════════ -->
    <!--  MODE LARGE : grille de vignettes avec recherche                        -->
    <!-- ═══════════════════════════════════════════════════════════════════════ -->
    @if (mode() === 'large') {
        <div class="thematic-large-container" @largeAnim>
            <!-- Barre d'outils : recherche + bouton Ajouter -->
            <div class="thematic-toolbar">
                <h3 class="mr-4 text-xl font-semibold leading-3">
                    {{ t('thematic-title') }}
                </h3>
                <mat-form-field
                    class="thematic-search-field"
                    appearance="outline"
                    subscriptSizing="dynamic"
                >
                    <mat-icon
                        matPrefix
                        svgIcon="heroicons_solid:magnifying-glass"
                    />
                    <input
                        matInput
                        [placeholder]="t('search-placeholder')"
                        [ngModel]="searchQuery()"
                        (ngModelChange)="searchQuery.set($event)"
                    />
                    @if (searchQuery()) {
                        <button
                            mat-icon-button
                            matSuffix
                            (click)="searchQuery.set('')"
                        >
                            <mat-icon svgIcon="heroicons_solid:x-mark" />
                        </button>
                    }
                </mat-form-field>

                <button mat-raised-button color="primary" (click)="onAdd()">
                    <mat-icon svgIcon="heroicons_mini:plus" />
                    {{ t('add') }}
                </button>
            </div>

            <!-- Grille de vignettes -->
            @if (filteredThematics().length > 0) {
                <div class="thematic-grid">
                    @for (thematic of filteredThematics(); track thematic.id) {
                        <div
                            class="thematic-card group"
                            [class.thematic-card--selected]="
                                current()?.id === thematic.id
                            "
                            (click)="onSelect(thematic)"
                            @zoomIn
                        >
                            <!-- En-tête : indicateur couleur + nom + secteur parent -->
                            <div class="mb-1 flex items-start justify-between">
                                <div
                                    class="flex min-w-0 flex-1 items-center gap-2"
                                >
                                    <div class="thematic-card__color-dot">
                                        <mat-icon
                                            class="thematic-card__dot-icon"
                                            svgIcon="heroicons_solid:document-text"
                                        />
                                    </div>
                                    <div class="flex min-w-0 flex-col">
                                        <h4
                                            class="thematic-card__name"
                                            [title]="thematic.name ?? ''"
                                        >
                                            {{ thematic.name }}
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <!-- Description -->
                            @if (thematic.description) {
                                <p
                                    class="thematic-card__description"
                                    [title]="thematic.description"
                                >
                                    {{ thematic.description }}
                                </p>
                            }

                            <!-- Pied : chips + actions -->
                            <div class="thematic-card__footer">
                                <div class="thematic-card__meta">
                                    @if (thematic.objectDefinitionsCount) {
                                        <span class="thematic-card__chip">
                                            <mat-icon
                                                class="thematic-card__chip-icon"
                                                svgIcon="heroicons_mini:cube"
                                            />
                                            {{
                                                thematic.objectDefinitionsCount
                                            }}
                                        </span>
                                    }
                                </div>
                                <div
                                    class="thematic-card__actions"
                                    (click)="$event.stopPropagation()"
                                >
                                    <button
                                        mat-icon-button
                                        color="accent"
                                        [matTooltip]="'common.edit' | transloco"
                                        (click)="onEdit(thematic, $event)"
                                    >
                                        <mat-icon
                                            svgIcon="heroicons_mini:pencil"
                                            class="icon-size-5"
                                        />
                                    </button>
                                    <button
                                        mat-icon-button
                                        color="warn"
                                        [matTooltip]="
                                            'common.delete' | transloco
                                        "
                                        (click)="onDelete(thematic, $event)"
                                    >
                                        <mat-icon
                                            svgIcon="heroicons_mini:trash"
                                            class="icon-size-5"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            } @else {
                <!-- Aucun résultat -->
                <app-no-data
                    [title]="
                        searchQuery()
                            ? t('no-search-results')
                            : t('no-thematics')
                    "
                    [showAction]="false"
                />
            }
        </div>
    }
</ng-container>
